import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-status-card',
  templateUrl: './status-card.component.html',
  styleUrls: ['./status-card.component.css']
})
export class StatusCardComponent {
  @Input() texto: string = 'Status';
  @Input() cor: string = '#ccc'; // ex: '#e74c3c'
  @Input() icone: string = 'schedule'; // ícone Material, como 'schedule', 'check', etc.
  @Input() descricao: string = ''; // Subtítulo
  @Input() backgroundColor: string = 'white'; // Cor de fundo do card
}
